import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { SingleSearchField, SingleSearchFieldProps } from './SingleSearchField';
import { MeiliIndex, SearchDatabaseResultItem, MeiliArtistData } from './types';
import { TypedMemo } from '../../../common/types';

export type ArtistSearchFieldProps = Omit<SingleSearchFieldProps, 'queryType' | 'onSelected' | 'placeholder'> & {
  onArtistSelected: (artist: MeiliArtistData) => void;
  placeholder?: string;
};

const ArtistSearchFieldComponent: React.FC<ArtistSearchFieldProps> = ({ onArtistSelected, placeholder, ...props }) => {
  const intl = useIntl();

  const defaultPlaceholder = intl.formatMessage({
    id: 'app.search.artists.placeholder',
    defaultMessage: 'Search for artists...',
  });

  const handleSelected = useCallback(
    (item: SearchDatabaseResultItem) => {
      if (item.type === MeiliIndex.artists) {
        onArtistSelected(item.item);
      }
    },
    [onArtistSelected]
  );

  return (
    <SingleSearchField
      queryType={MeiliIndex.artists}
      onSelected={handleSelected}
      placeholder={placeholder || defaultPlaceholder}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
};

export const ArtistSearchField = TypedMemo(ArtistSearchFieldComponent);
